import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MoveToEventService {

  constructor() { }

  private eventClickedSource = new Subject<any>();
  eventClicked$ = this.eventClickedSource.asObservable();

  emitEventClicked(event: any) {
    this.eventClickedSource.next(event);
  }
}
